<template>
  <div></div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/messaging";
import { notifyMixin } from "@/mixins/notifyMixin";
import { eventBus } from "@/main";

export default {
  name: "Notification",
  data() {
    return {
      messaging: null,
      notifAudio: new Audio(require("@/assets/notif.mp3")), // notif sound
    };
  },
  mixins: [notifyMixin],
  methods: {
    processNotification(payload) {
      this.notifAudio.play();
      // Assigned task
      if (payload.data.type == "assign") {
        this.assignedTask(payload);
      }
      // Removed from task
      else if (payload.data.type == "remove") {
        this.removedTask(payload);
      }
      // Task completed
      else if (payload.data.type == "completed-task") {
        this.completedTask(payload);
      }
      // New comment
      else if (payload.data.type == "new-comment") {
        this.newComment(payload);
      }
      // Accept invitation
      else if (payload.data.type == "accept-invitation") {
        this.acceptInvitation(payload);
      }
    },

    /* Recieve foreground notifications */
    receiveMessage() {
      try {
        if (this.messaging)
          this.messaging.onMessage((payload) => {
            console.log("fg notif", payload);
            console.log(payload.data.type);
            // USING SHOW NOTIF ON FOREGROUND
            if ("serviceWorker" in navigator) {
              let options = {
                body: payload.data.body,
                icon: payload.data.icon,
                data: payload.data,
                requireInteraction: navigator.platform.includes("Mac"),
              };
              payload.data.actions && localStorage.getItem("role") != "employee"
                ? (options.actions = JSON.parse(payload.data.actions))
                : () => {};
              navigator.serviceWorker
                .getRegistrations()
                .then((registrations) => {
                  for (let reg of registrations) {
                    if (reg.scope.includes("firebase")) {
                      reg.showNotification(payload.data.title, options);
                    }
                  }
                });
            }
          });
      } catch (e) {
        console.log("e", e);
      }
    },
  },
  created() {
    if ("serviceWorker" in navigator) {
      if (navigator.userAgent.indexOf("Chrome") > -1)
        try {
          this.messaging = firebase.messaging();
          this.receiveMessage();
        } catch (err) {
          console.log(err);
        }
    }
  },
  mounted() {
    eventBus.$on("notification", this.processNotification);
  },
  beforeDestroy() {
    eventBus.$off("notification");
  },
};
</script>
